import React, { useEffect } from "react";
import { Spin } from "antd";
import { useVCESiframe } from "@companion-core/shared/app/Components/VCES/VCESiframe/hooks/vcesIframe";
import "@companion-core/web/src/Assets/Styles/scss/vces.scss";

export const VCESiframe = () => {
  const { t, isFetching, completeVCESUrl, setRegisterContent } = useVCESiframe();

  const messageListener = (event: MessageEvent) => {
    if (event.data !== "vces_validated") return;
    setRegisterContent("vces-validator");
  };

  useEffect(() => {
    window.addEventListener("message", messageListener, false);
    return () => window.removeEventListener("message", messageListener);
  }, []);

  return isFetching ? (
    <Spin className="vces-loader" />
  ) : (
    <div className="vces">
      <h2 className="vces__title title-6">{t("register.vces.pan.title")}</h2>
      <span className="vces__label body-text-5">{t("register.vces.pan.label")}</span>
      <iframe
        id="vces__iframe"
        sandbox="allow-forms allow-scripts"
        className="vces__iframe"
        src={completeVCESUrl}
      />
    </div>
  );
};
